import { TaskMetaInformation } from '../interfaces/task-meta-information.interface';

export interface GetProjectsTasksDto {
    tasks: TaskMetaInformation[];
    totalCount: number;
}
